import {
  useCreateExternalStorage,
  useDeleteExternalStorage,
  useGetExternalStorageById,
  useUpdateExternalStorage
} from "../../../../../api/general/storage";
import {
  useCreateExternalStorageSimulation,
  useDeleteExternalStorageSimulation,
  useGetExternalStorageSimulationById,
  useUpdateExternalStorageSimulation
} from "../../../../../api/general/simulationStorage";
import {
  useCreateExternalStorage as useCreateSupplierExternalStorage,
  useDeleteExternalStorage as useDeleteSupplierExternalStorage,
  useGetExternalStorageById as useGetSupplierExternalStorageById,
  useUpdateExternalStorage as useUpdateSupplierExternalStorage
} from "../../../../../api/general/supplierStorage";
import { ExternalStorageToolVariant } from "./externalStorage.types";

type ExternalStorageApiHookSet = {
  useGetById: (id: string | null) => {
    data: any;
    status: string;
    fetchStatus?: string;
    isLoading?: boolean;
    refetch?: () => Promise<any>;
  };
  useCreate: () => { mutate: (...args: any[]) => void; isLoading: boolean };
  useUpdate: () => { mutate: (...args: any[]) => void; isLoading: boolean };
  useDelete: () => { mutate: (...args: any[]) => void; isLoading?: boolean };
  useGetOriginalById: (id: string | null | undefined) => {
    data: any;
    isLoading?: boolean;
    refetch?: () => Promise<any>;
  };
};

export const EXTERNAL_STORAGE_API_HOOKS: Record<
  ExternalStorageToolVariant,
  ExternalStorageApiHookSet
> = {
  mapping: {
    useGetById: useGetExternalStorageById,
    useCreate: useCreateExternalStorage,
    useUpdate: useUpdateExternalStorage,
    useDelete: useDeleteExternalStorage,
    useGetOriginalById: useGetExternalStorageById
  },
  simulate: {
    useGetById: useGetExternalStorageSimulationById as ExternalStorageApiHookSet["useGetById"],
    useCreate: useCreateExternalStorageSimulation,
    useUpdate: useUpdateExternalStorageSimulation,
    useDelete: useDeleteExternalStorageSimulation,
    useGetOriginalById: useGetExternalStorageById
  },
  supplier: {
    useGetById: useGetSupplierExternalStorageById,
    useCreate: useCreateSupplierExternalStorage,
    useUpdate: useUpdateSupplierExternalStorage,
    useDelete: useDeleteSupplierExternalStorage,
    useGetOriginalById: useGetSupplierExternalStorageById
  }
};

export const getExternalStorageApiHooks = (
  variant: ExternalStorageToolVariant
): ExternalStorageApiHookSet => EXTERNAL_STORAGE_API_HOOKS[variant];
